import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { startGetCamposServicio, startGetListaItems } from "../../../../context/actions/crearServiciosV2Actions";

export const useCamposServicio = (servicioID) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [camposOpciones, setCamposOpciones] = useState({});

  useEffect(() => {
    if (!servicioID) return;

    const load = async () => {
      setLoading(true);
      try {
        const result = await dispatch(startGetCamposServicio(servicioID));
        const campos = result.success ? result.data : [];
        const opciones = {};
        for (const campo of campos) {
          if (campo.tipo === "lista" && campo.listaID) {
            const listaResult = await dispatch(startGetListaItems(campo.listaID));
            opciones[campo.id] = listaResult.success ? listaResult.data : [];
          }
        }
        setCamposOpciones(opciones);
      } catch (error) {
        console.error("Error cargando campos:", error);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [servicioID]);

  return { loading, camposOpciones };
};
